// extracted by mini-css-extract-plugin
export default {"meta":"Benefit_meta__bEGaY","desc":"Benefit_desc__oPcc-","heading":"Benefit_heading__OO8Tr"};